var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block div-mg-all"},[_c('el-image',{staticStyle:{"width":"100%","height":"80%"},attrs:{"src":_vm.imgSrc,"fit":"fill"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }